// extracted by mini-css-extract-plugin
module.exports = {"modal":"metadata_modal_OcIpAYa","header":"metadata_header_2iGF6bX"};